var _excluded = ["placement"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { forwardRef, tqc, useStyles } from '../../system';
import { cx } from '../../utils';
var placements = {
  left: {
    marginRight: '-1px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRightColor: 'transparent'
  },
  right: {
    marginLeft: '-1px',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeftColor: 'transparent'
  }
};
var StyledAddon = tqc('div', {
  baseStyle: {
    flex: '0 0 auto',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap'
  }
});
/**
 * InputAddon
 *
 * Element to append or prepend to an input
 */
export var InputAddon = forwardRef((props, ref) => {
  var _placements$placement;
  var {
      placement = 'left'
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var placementStyles = (_placements$placement = placements[placement]) !== null && _placements$placement !== void 0 ? _placements$placement : {};
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(StyledAddon, _extends({
    ref: ref
  }, rest, {
    __css: _objectSpread(_objectSpread({}, styles.addon), placementStyles)
  }));
});
InputAddon.displayName = 'InputAddon';

/**
 * InputLeftAddon
 *
 * Element to append to the left of an input
 */
export var InputLeftAddon = forwardRef((props, ref) => /*#__PURE__*/React.createElement(InputAddon, _extends({
  ref: ref,
  placement: "left"
}, props, {
  className: cx('tqc-input__left-addon')
})));
InputLeftAddon.displayName = 'InputLeftAddon';
InputLeftAddon.id = 'InputLeftAddon';

/**
 * InputRightAddon
 *
 * Element to append to the right of an input
 */
export var InputRightAddon = forwardRef((props, ref) => /*#__PURE__*/React.createElement(InputAddon, _extends({
  ref: ref,
  placement: "right"
}, props, {
  className: cx('tqc-input__right-addon')
})));
InputRightAddon.displayName = 'InputRightAddon';

// This is used in `input-group.tsx`
InputRightAddon.id = 'InputRightAddon';